import enContent from "../data/eng-content.json";
import frContent from "../data/fr-content.json";
import { useLanguage } from "./LanguageContext";

export const useLanguageContent = () => {
    const { selectedLanguage } = useLanguage();

    return selectedLanguage === "fr" ? frContent : enContent;
};